import cx from 'classnames';
import { Component, h } from 'preact';

import TinyMap from './TinyMap';

import text from 'Data/text.json';
import MiniBarChart from './MiniBarChart';

interface Props {
  category: string;
  maxNum: number;
  categoryNumbers: { [key: string]: any };
  contest: { [key: string]: any };
  candidates: { [key: string]: any };
  candidatesRender: any;
}

class AnalysisTableRow extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      category,
      categoryNumbers,
      candidatesRender,
      contest,
      maxNum,
      candidates,
    } = this.props;

    let categoryClass = cx(
      'category-bar-chart-' + category + '-' + contest.office_slug
    );

    const category_text = text.geocategories.find((a) => a.type == category)[
      'value'
    ];

    const category_explain = text.geocategories_explain.find(
      (a) => a.type == category
    )['value'];

    return (
      <div class='category-grid t-sans'>
        <h4 class='map__title'>{category_text}</h4>
        <p class='map__explain'>{category_explain}</p>
        <div class='category-inline-grid'>
          <TinyMap
            contest={contest}
            category={category}
            candidatesRender={candidatesRender}
          />
          <div class={categoryClass}>
            <MiniBarChart
              className={category}
              maxNum={maxNum}
              officeSlug={contest.office_slug}
              categoryNumbers={categoryNumbers}
              candidatesRender={candidatesRender}
              candidates={candidates}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AnalysisTableRow;